







































// @ts-nocheck
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getTagsByName } from '@/services/uploads'
import Popup from '@/components/popup/index.vue'

 

@Component({
  components: {
    Popup,
  },
})
export default class VideoClassify extends Vue {
  $toast: any
  tagList: Array<any> = []
  selectTagList: Array<any> = []
  userclassTagArr?: Array<string> = []
  popShow: Boolean = true
  query: String = ''
  
  @Prop() formData?: UploadVideoAPI.UploadFrom
  @Prop() selectCliArr?: Array<any>
  @Prop() show?: true

  @Watch('show')
  watchShow(newval: Boolean) {

    this.popShow = newval
  }

  mounted() {
    this.selectTagList = []
    this.tagList = []
    this.fetchData('')
  }
  async fetchData(query) {
    this.tagList = []
    const req = await getTagsByName({'tagType': 3, 'tagName': query})
      if (req.code === 200 && req.data.length > 0) {
      this.tagList = []
      for (const i of req.data) {
        const obj = {}
        obj.value = `${i.tagName},${i.tagId}`
        obj.tagName = i.tagName
        // for (const t of this.selectCliArr) {
        //   if (i.tagName == t.tagName) {
        //     obj.class = true
        //     this.selectTagList.push(i)
        //   }
        // }
        // this.selectTagList = this.remake('tagName',this.selectTagList)
        this.tagList.push(obj)
      }
    } else {
      this.tagList = []
    }
  }

  remake(name,json) {
    let arr = [];
    for(let i = 0;i<json.length;i++){
      let flag = false;
      for(let j=0;j<arr.length;j++){
        if(json[i][name] == arr[j][name]){
          flag = true;
        }
      }
      if (!flag){
        arr.push(json[i]);
      }
    }
    return arr;
  }
  
  closeDialog() {
    this.popShow = false
    this.$emit('close', this.selectTagList)
  }

  clearSearch() {
    this.query = ''
    this.fetchData('')
  }

  onChange(e: any) {
    this.query = e.target.value
    if (this.query !== '') {
      this.tagList = []
      this.fetchData(this.query)
    } else {
      this.fetchData('')
    }
  }

  // 删除标签
  SelectDataClose(data) {
    this.userclassTagArr = this.userclassTagArr.filter(
      item => item.tagName !== data.tagName
    )
    this.selectTagList = this.selectTagList.filter(
      item => item.tagName !== data.tagName
    )
    this.eachTag({
      type: 'remove',
      data,
    })
    // 数组转成字符串
    this.formData.userclassTag = this.concatArr(
      this.userclassTagArr
    )
  }

  // 推荐标签增加active class
  eachTag({ type, data }) {
    const domList = document.querySelectorAll('.el-tag-open')
    for (let i = 0; i < domList.length; i += 1) {
      if (domList[i].dataset.text === data.tagName) {
        domList[i].classList[type]('active')
      }
    }
  }

  // 选中标签
  handlerTag(i, e) {
    if (this.formData.userclipTag.includes(this.tagList[i].tagName)) {
      this.userclassTagArr = this.userclassTagArr.filter(
        item => item.tagName !== this.tagList[i].tagName
      )
      e.target.classList.remove('active')
      this.selectTagList = this.selectTagList.filter(
        item => item.tagName !== this.tagList[i].tagName
      )
    } else if (this.userclassTagArr.length < 3) {
      this.userclassTagArr.push(this.tagList[i])
      this.selectTagList.push(this.tagList[i])
      e.target.classList.add('active')
    } else {
      return this.$toast('只可选择3个作品')
    }
    // 数组转成字符串
    this.formData.userclipTag = this.concatArr(
      this.userclassTagArr
    )
  }

  concatArr(arr) {
    let strs = ''
    for (let i = 0; i < arr.length; i += 1) {
      strs += `${arr[i].value}|`
    }
    return strs
  }

}
